import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components //
import Text from 'components/Text';

const Root = styled.button`
  box-sizing: border-box;
  background-color: ${ ({ color, theme, type }) =>
    type === 'standard' ?
      theme.color[color]
      : 'transparent'
  };
  background-image: ${ ({ type }) =>
    type === 'standard' && `linear-gradient(-180deg, rgba(255,255,255,0.12) 0%, rgba(0,0,0,0.12) 100%)`
  };
  box-shadow: 0 1px 1px 0 #005EAD, 0 3px 16px 0 rgba(0,125,238,.32);
  border: ${ ({ color, theme, type }) => type !== 'standard' ?
    `2px solid ${ theme.color[color]}`
    : 0
  };
  padding: ${ ({ large }) => large ? '16px 48px' : '6px 9px' };
  border-radius: 4px;
  cursor: ${ ({ disabled }) => disabled ? 'not-allowed' : 'pointer' };
  opacity: ${ ({ disabled }) => disabled ? .5 : 1 };
  transition: 0.2s box-shadow ${ ({ theme }) => theme.easing.default };

  &:hover {
    box-shadow: 0 1px 2px 0 #005EAD, 0 4px 16px 0 rgba(0,125,238,.4);
  }

  &:active {
    box-shadow: 0 1px 1px 0 #005EAD, 0 3px 16px 0 rgba(0,125,238,.32);
  }

  & > ${ Text } {
    font-family: 'Realtime Text', sans-serif;
    user-select: none;
    vertical-align: middle;
    line-height: 20px;
    min-width: 61px;
    color: ${ ({ color, theme, type }) =>
    type === 'standard' ?
      (color === 'light' || color === 'white') ?
        theme.color.primary
        : theme.color.white
      : theme.color[color] };
  }
`;

const Button = ({
  label,
  onClick,
  ...rest
}) => {
  return (
    <Root
      onClick={rest.disabled ? null : onClick}
      {...rest}
    >
      <Text
        size={rest.large ? 16 : 14}
        weight="600"
      >
        { label }
      </Text>
    </Root>
  )
}

Button.propTypes = {
  color: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  large: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf([
    'standard',
    'outlined',
  ]).isRequired,
};

Button.defaultProps = {
  color: 'primary',
  type: 'standard',
}

export default Button;
